/**
 * Responsibility: the news page data.
 *
 * Refetched far less often than the Nodes panel. News moves on the hour at
 * best, and a 15-second poll would be asking the hub a question whose answer
 * cannot have changed.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { hubApi } from '../client';

const NEWS_REFRESH_MS = 300_000;

export function useNewsItems(limit = 50) {
  return useQuery({
    queryKey: ['news', 'items', limit],
    queryFn: () => hubApi.listNews(limit),
    refetchInterval: NEWS_REFRESH_MS,
  });
}

export function useDropSignals() {
  return useQuery({
    queryKey: ['news', 'signals'],
    queryFn: hubApi.listDropSignals,
    refetchInterval: NEWS_REFRESH_MS,
  });
}

export function useNewsSources() {
  return useQuery({ queryKey: ['news', 'sources'], queryFn: hubApi.newsSources });
}

export function useSweepNews() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: hubApi.sweepNews,
    // A sweep can add articles and move a signal across the threshold, so
    // both lists are stale the moment it returns.
    onSuccess: () => client.invalidateQueries({ queryKey: ['news'] }),
  });
}
